module.exports = __webpack_public_path__ + "img/73.e62523c3.jpg";